/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Shift } from '../../models/shift';

export interface GetShifts$Params {
  workCenterId: number;
}

export function getShifts(http: HttpClient, rootUrl: string, params: GetShifts$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Shift>>> {
  const rb = new RequestBuilder(rootUrl, getShifts.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Shift>>;
    })
  );
}

getShifts.PATH = '/api/v1/ShiftReport/{workCenterId}';
